// extracted by mini-css-extract-plugin
module.exports = {"tagline":"hero__tagline","hero":"hero__hero","letterBox":"hero__letterBox","changeAction":"hero__changeAction"};